import RecipeSite from "./recipe-site";

export default RecipeSite;
